import { comments } from '@/mocks/home';

export default function CommentsSection() {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`text-xs ${i < rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-background-300'}`}
      ></i>
    ));
  };

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              影迷评价
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              影迷真实反馈
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              听听蓝莓影院的用户怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {comments.map((comment) => (
              <article
                key={comment.id}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="flex items-start gap-4">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                    loading="lazy"
                    width="48"
                    height="48"
                    title={comment.name}
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="text-sm font-bold text-foreground-900">{comment.name}</h3>
                      <span className="text-xs text-foreground-400">{comment.date}</span>
                    </div>
                    <div className="flex items-center gap-0.5 mb-2">
                      {renderStars(comment.rating)}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {comment.content}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}